import { render, staticRenderFns } from "./CustomerAlsoBought.vue?vue&type=template&id=320426d4&scoped=true"
import script from "./CustomerAlsoBought.vue?vue&type=script&lang=js"
export * from "./CustomerAlsoBought.vue?vue&type=script&lang=js"
import style0 from "./CustomerAlsoBought.vue?vue&type=style&index=0&id=320426d4&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "320426d4",
  null
  
)

export default component.exports